<loading *ngIf="loading" class="full">
  <ng-container i18n="@@cryptoPrices.loading">Loading data...</ng-container>
</loading>

<error *ngIf="error" class="full">
  {{error}}
</error>

<div *ngIf="!loading && !error" class="row tabs">
  <div class="d-flex col-lg crypto-wrap">
    <a *ngFor="let currency of fiatCurrencies" href="javascript: void(0);" class="tab" [class.active]="currency.code === fiatCurrency" (click)="setFiatCurrency(currency.code)">{{currency.code}}</a>
  </div>

  <div class="d-flex col-lg-auto justify-content-center p-0 my-3 m-lg-2">
    <ng-container *ngTemplateOutlet="chartIntervalSwitch"></ng-container>
  </div>
</div>

<div *ngIf="!loading && !error" class="list">
  <div *ngIf="showHeader" class="list-header row d-none d-lg-flex">
    <div class="col-3" i18n="@@cryptoPrices.header.digitalAsset">Digital Asset</div>
    <div class="col-2" i18n="@@cryptoPrices.header.price">Price</div>
    <ng-container *ngTemplateOutlet="changeColumnHeader; context: {duration: duration}"></ng-container>
    <ng-container *ngTemplateOutlet="chartColumnHeader; context: {duration: duration}"></ng-container>
    <div class="col"></div>
  </div><!-- .list-header -->
  <div class="list-body">
    <crypto-list-item *ngFor="let currency of currencies"
      [currency]="currency"
      [baseCurrencyCode]="fiatCurrency"
      [duration]="duration"
      (update)="onDataChange($event)">
    </crypto-list-item>
  </div><!-- .list-body -->
</div><!-- .list -->
<div *ngIf="showUpdateDate" class="update-time" i18n="@@cryptoPrices.lastUpdated">Prices Last Updated: {{lastUpdateDate | date:'medium'}}</div>


<ng-template #chartIntervalSwitch>
  <chart-duration-picker [duration]="duration" (durationChange)="changeDuration($event)"></chart-duration-picker>
</ng-template>

<ng-template #changeColumnHeader let-duration="duration">
  <div class="col-2" [ngSwitch]="duration">
    <ng-container *ngSwitchCase="PriceChartDuration.OneDay" i18n="@@pricePage.change.headerTitle.24hours">Change (24 Hours)
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.SevenDays" i18n="@@pricePage.change.headerTitle.7days">Change (7 Days)
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.OneMonth" i18n="@@pricePage.change.headerTitle.1month">Change (1 Month)
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.ThreeMonths" i18n="@@pricePage.change.headerTitle.3months">Change (3 Months)
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.OneYear" i18n="@@pricePage.change.headerTitle.1year">Change (1 Year)
    </ng-container>
    <ng-container *ngSwitchDefault i18n="@@pricePage.change.durations.24hours">Change (24 Hours)
    </ng-container>
  </div>
</ng-template>

<ng-template #chartColumnHeader let-duration="duration">
  <div class="col-2" [ngSwitch]="duration">
    <ng-container *ngSwitchCase="PriceChartDuration.OneDay" i18n="@@pricePage.chart.headerTitle.24hours">24 Hours Chart
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.SevenDays" i18n="@@pricePage.chart.headerTitle.7days">7 Days Chart
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.OneMonth" i18n="@@pricePage.chart.headerTitle.1month">1 Month Chart
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.ThreeMonths" i18n="@@pricePage.chart.headerTitle.3months">3 Months
      Chart
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.OneYear" i18n="@@pricePage.chart.headerTitle.1year">1 Year Chart
    </ng-container>
    <ng-container *ngSwitchDefault i18n="@@pricePage.chart.durations.24hours">24 Hours Chart
    </ng-container>
  </div>
</ng-template>
